'use client';

import { CtaCaseData } from '@sapientpro/sapientpro-data-models';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { useAtomValue } from 'jotai';
import Link from 'next/link';
import Img from '../../components/Img';
import styles from './CasesSlider.module.scss';
import '@splidejs/react-splide/css';
import CustomCursorWrapper from '../../components/CustomCursor/CustomCursorWrapper';
import deviceScreenSize, { ScreenSize } from '../../store/deviceScreenSize';

const CircleSlider = ({ data }: { data: CtaCaseData[] }) => {
  const deviceSize = useAtomValue(deviceScreenSize);

  const sliderGap = deviceSize < ScreenSize.TABLET_PORTRAIT ? 14 : 26;

  return (
    <CustomCursorWrapper
      cursorText='drag'
      view='light'
    >
      <div
        className={styles.casesSliderBlock}
      >
        <Splide
          hasTrack={false}
          options={{
            focus: 'center',
            pagination: false,
            type: 'loop',
            autoWidth: true,
            perPage: 3,
            arrows: false,
            gap: sliderGap,
          }}
          className={styles.slider}
        >
          <SplideTrack
            className={styles.sliderTrack}
          >
            {data.map(item => {
              const image = item.case.previewImage || item.case.image;
              const title = item.case.previewTitle || item.case.title;

              return (
                <SplideSlide
                  className={styles.caseSlide}
                  key={item.id}
                >
                  <div>
                    <Img
                      src={image?.url}
                      height={image.height || 0}
                      width={image.width}
                      className={styles.caseImage}
                    />
                  </div>
                  <Link
                    href={`cases/${item.case.slug}`}
                    className={styles.caseDescription}
                  >
                    <h3 className={styles.description}>{title}</h3>
                    <p className={styles.title}>{item.case.projectName}</p>
                  </Link>
                </SplideSlide>
              );
            })}
          </SplideTrack>
        </Splide>
      </div>
    </CustomCursorWrapper>

  );
};

export default CircleSlider;
